/**
 * Delivery-location prompt card — shown inline in the chat feed, styled like
 * OrderConfirmCard, while the AI is waiting on a delivery address. Offers the
 * two non-typing shortcuts (GPS location, or the map picker) alongside just
 * typing the address as a normal chat message.
 */
import React from "react";
import { MapPin, Map as MapIcon } from "lucide-react";
import { Button } from "@/components/ui/button";

export function LocationPromptCard({ onUseCurrentLocation, onPickOnMap, busy }) {
  return (
    <div className="bg-card border rounded-2xl p-4 shadow-elegant max-w-md" data-testid="location-prompt-card">
      <p className="text-[10px] font-bold uppercase tracking-widest text-primary pb-2">Delivery location</p>
      <p className="text-sm text-muted-foreground pb-3">
        Type your address below, or use a shortcut:
      </p>
      <div className="grid grid-cols-2 gap-2">
        <Button
          type="button" variant="outline" className="gap-1.5 text-xs h-9"
          onClick={onUseCurrentLocation} disabled={busy}
          data-testid="chat-use-current-location"
        >
          <MapPin className="w-3.5 h-3.5" />
          Current location
        </Button>
        <Button
          type="button" variant="outline" className="gap-1.5 text-xs h-9"
          onClick={onPickOnMap} disabled={busy}
          data-testid="chat-pick-on-map"
        >
          <MapIcon className="w-3.5 h-3.5" />
          Pick on map
        </Button>
      </div>
    </div>
  );
}
